import React, { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "./home.scss";
import { Grid, Container, Box } from "@mui/material";
import { Pause, PlayArrow, ArrowBack, ArrowForward } from "@mui/icons-material";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import HeaderNew from "../../layout/header/Header-new";
import { templesData } from "../../data/templesData.js";
import { allStatesData, allCitiesData } from "../../data/indiaLocationsData.js";

function HomePageWhite() {

    
    const services = [
        {
            name: "Discover temples",
            title: (
                <>
                   Discover temples
                </>
            ),
            icon: "/assets/home/icons/service-icon-1.webp",
            link: "india-map"
        },
        {
            name: "Panchang",
            title: (
                <>
                    Panchang
                </>
            ),
            icon: "/assets/home/icons/punchang.webp",
            link: "coming-soon"
        },
        {
            name: "Samay AI",
            title: (
                <>
                    Samay AI
                </>
            ),
            icon: "/assets/home/icons/ai.webp",
            link: "coming-soon"
        },
        {
            name: "Travel booking",
            title: (
                <>
                    Travel booking
                </>
            ),
            icon: "/assets/home/icons/service-icon-4.webp",
            link: "coming-soon"
        },
        {
            name: "Mythic kids",
            title: (
                <>
                    Mythic kids
                </>
            ),
            icon: "/assets/home/icons/kids.webp",
            link: "coming-soon"
        },
        {
            name: "Blogs",
            title: (
                <>
                    Blogs
                </>
            ),
            icon: "/assets/home/icons/blogs.webp",
            link: "coming-soon"
        },
        {
            name: "Certificate",
            title: (
                <>
                    Certificate
                </>
            ),
            icon: "/assets/home/icons/certificate.webp",
            link: "coming-soon"
        },
        {
            name: "Hire a pandit",
            title: (
                <>
                    ⁠Hire a pandit
                </>
            ),
            icon: "/assets/home/icons/pandit.webp",
            link: "coming-soon"
        },
        {
            name: "Pilgrimage Financing",
            title: (
                <>
                   ⁠Pilgrimage Financing
                </>
            ),
            icon: "/assets/home/icons/pilgrimage.webp",
            link: "coming-soon"
        },
        {
            name: "Horoscope",
            title: (
                <>
                    Horoscope
                </>
            ),
            icon: "/assets/home/icons/horoscope.webp",
            link: "coming-soon"
        },
        {
            name: "Weather",
            title: (
                <>
                    Weather
                </>
            ),
            icon: "/assets/home/icons/wheather.webp",
            link: "coming-soon"
        },
        {
            name: "Audio guide",
            title: (
                <>
                    Audio guide
                </>
            ),
            icon: "/assets/home/icons/audio.webp",
            link: "coming-soon"
        },
        {
            name: "Reunite tag",
            title: (
                <>
                    ⁠Reunite tag
                </>
            ),
            icon: "/assets/home/icons/tag.webp",
            link: "coming-soon"
        },
    ];

    const famousTemples = [
         {
            title: "Vaishno Devi",
            image: "/assets/trending/vaishno-devi.webp",
            link: "vaishno-devi",
        },
        {
            title: "Dwarkadhish",
            image: "/assets/trending/dwarkadhish.webp",
            link: "dwarkadhish-temple",
        },
        {
            title: "Ayodhya",
            image: "/assets/trending/ayodhya-mandir.webp",
            link: "ayodhya",
        },
        {
            title: "Kashi Vishwanath",
            image: "/assets/trending/kashi-vishwanath.webp",
            link: "kashi-vishwanath",
        },
        {
            title: "Rameshwaram",
            image: "/assets/trending/rameshwaram.webp",
            link: "ramanathaswamy-temple",
        },
       
    ];

    const actionCards = [
        {
            title: "Locker Booking",
            description: "Secure smart lockers to store your belongings safely.",
            image: "/assets/home/what-to-do/temple-1.webp",
            link: "locker",
        },
        {
            title: "Navi Stick",
            description: "Smart walking support & balance for steep pilgrimage climbs.",
            image: "/assets/home/what-to-do/temple-2.webp",
            link: "navi-stick",
        },
        {
            title: "Reunite Band",
            description: "QR-enabled wristband to keep children & elders safe in crowds.",
            image: "/assets/home/what-to-do/temple-3.webp",
            link: "reunite-band-service",
        },
        {
            title: "VR Darshan",
            description: "Experience 360° virtual temple darshan & sacred rituals from home.",
            image: "/assets/home/what-to-do/temple-4.webp",
            link: "coming-soon",
        },
        {
            title: "Saarthi",
            description: "Verified personal guides for route guidance & elderly care.",
            image: "/assets/home/what-to-do/temple-5.webp",
            link: "sarthi-service",
        },
        {
            title: "Yatri Pack",
            description: "Complete travel hygiene & comfort kit for a worry-free yatra.",
            image: "/assets/home/what-to-do/temple-6.webp",
            link: "yatri-pack",
        },
        {
            title: "Packages",
            description: "Curated spiritual tour packages for families & groups.",
            image: "/assets/vaishno-packages/package-1.webp",
            link: "vaishno-devi-package",
        },
        // {
        //     title: "Varanasi Package",
        //     description: "Curated Kashi Vishwanath & Varanasi spiritual tour packages.",
        //     image: "/assets/varanasi-packages/package-1.webp",
        //     link: "varanasi-package",
        // },
        {
            title: "Souvenirs",
            description: "Sacred mementos, holy prasad, idols & spiritual gifts.",
            image: "/assets/home/what-to-do/temple-8.webp",
            link: "https://shop.mandir.wiki/",
        },
    ];

    const blogs = [
        {
            title: "Kedarnath Temple",
            description:
                "Divine Trek into the Heart of the Himalayas. This one line captures the unwavering devotion of millions of pilgrims who brave rugged terrain, steep mountain trails, and unpredictable weather to experience the eternal presence of Lord Shiva...",
            image: "/assets/home/blogs/blog-img-1.webp",
            link: "#",
        },
        {
            title: "Dwarkadhish Temple",
            description:
                "The Eternal Kingdom of Lord Krishna. A sacred tale of spiritual connection and ancient architectural brilliance, where devotees immerse themselves in centuries-old traditions, devotion, and the divine coastal aura of Dwarka...",
            image: "/assets/home/blogs/blog-img-2.webp",
            link: "#",
        },
        {
            title: "Ganesh Chaturthi",
            description:
                "Discover why Ganesh Chaturthi is celebrated. Know the mythological story of Lord Ganesha. Understand the meaning of the 10-day festival. Explore its religious significance, sacred rituals, and grand celebrations...",
            image: "/assets/home/blogs/ganesh-chaturthi.png",
            link: "#",
        },
        {
            title: "Gangotri Temple",
            description:
                "In the Lap of the Ganges and the Himalayas. Explore one of the most sacred pilgrimage shrines dedicated to Goddess Ganga, nestled amidst snow-clad Himalayan peaks, peaceful cedar forests, and divine spiritual serenity...",
            image: "/assets/home/blogs/blog-img-4.webp",
            link: "#",
        },
    ];

    const templeMysteries = [
        {
            title: "KEDARNATH",
            subtitle: "Mysteries and Marvels of Temples",
            tag: "KEDARNATH",
            paragraphs: [
                "It is believed to be one of the 12 Jyotirlingas, and its history and construction remain shrouded in some mystery, with legends connecting it to the Pandavas.",
                "The temple's unique architecture and its survival during the 2013 floods add to its mystique."
            ],
            banner: "/assets/home/kedarnath-mystery-bg.jpg",
            image: "/assets/trending/kedarnath.webp",
        },
        {
            title: "DWARKADHISH",
            subtitle: "Mysteries and Marvels of Temples",
            tag: "DWARKADHISH",
            paragraphs: [
                "Marine archaeological explorations off the Gujarat coast uncovered submerged stone structures, ancient fortified piers, and anchors dating back millennia.",
                "These deep-sea ruins provide striking tangible evidence of Lord Krishna's legendary golden city of Dwarka submerged beneath the sea."
            ],
            banner: "/assets/home/dwarkadhish-mystery-bg.jpg",
            image: "/assets/trending/dwarkadhish.webp",
        },
    ];

    const [mysteryPlaying, setMysteryPlaying] = useState(false);
    const [mysterySwiper, setMysterySwiper] = useState(null);
    const [mysteryIndex, setMysteryIndex] = useState(0);

    useEffect(() => {
        if (mysterySwiper && !mysteryPlaying) {
            mysterySwiper.autoplay?.stop?.();
        }
    }, [mysterySwiper, mysteryPlaying]);

    const toggleMysteryPlay = () => {
        if (!mysterySwiper) return;
        if (mysteryPlaying) {
            mysterySwiper.autoplay?.stop?.();
            setMysteryPlaying(false);
        } else {
            mysterySwiper.autoplay?.start?.();
            setMysteryPlaying(true);
        }
    };

    const handleMysteryPrev = () => {
        if (mysterySwiper) mysterySwiper.slidePrev();
    };

    const handleMysteryNext = () => {
        if (mysterySwiper) mysterySwiper.slideNext();
    };

    // Hero search states and handlers
    const navigate = useNavigate();
    const searchRef = useRef(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [showSuggestions, setShowSuggestions] = useState(false);

    const searchableTemples = useMemo(() => {
        // Priority static temples with dedicated routes matching Listing.jsx
        const priorityTemples = [
            {
                type: "temple",
                name: "Shri Kedarnath Temple",
                location: "Rudraprayag, Uttarakhand",
                route: "/kedarnath",
                image: "/assets/banner/vr-darshan/temples/kedarnath.webp",
                slug: "kedarnath",
                deity: "Lord Shiva",
                keywords: ["shiva", "kedar", "uttarakhand", "char dham", "jyotirlinga", "himalayas", "bhole", "mahadev", "rudraprayag"]
            },
            {
                type: "temple",
                name: "Mata Vaishno Devi Temple",
                location: "Katra, Jammu & Kashmir",
                route: "/vaishno-devi",
                image: "/assets/trending/vaishno-devi.webp",
                slug: "vaishno-devi",
                deity: "Mata Vaishno Devi",
                keywords: ["vaishno devi", "katra", "mata rani", "durga", "jammu", "bhavan", "shrine", "devi", "jammu & kashmir"]
            },
            {
                type: "temple",
                name: "Kashi Vishwanath Temple",
                location: "Varanasi, Uttar Pradesh",
                route: "/kashi-vishwanath",
                image: "/assets/trending/kashi-vishwanath.webp",
                slug: "kashi-vishwanath",
                deity: "Lord Shiva",
                keywords: ["kashi", "vishwanath", "banaras", "varanasi", "ganga", "shiva", "jyotirlinga", "mahadev", "uttar pradesh"]
            },
            {
                type: "temple",
                name: "Ayodhya Ram Mandir (Shri Ram Janmabhoomi)",
                location: "Ayodhya, Uttar Pradesh",
                route: "/ayodhya",
                image: "/assets/trending/ayodhya-mandir.webp",
                slug: "ayodhya",
                deity: "Lord Ram",
                keywords: ["ram", "ayodhya", "janmabhoomi", "shri ram", "mandir", "uttar pradesh", "ram lalla"]
            },
            {
                type: "temple",
                name: "Dwarkadhish Temple",
                location: "Dwarka, Gujarat",
                route: "/dwarkadhish-temple",
                image: "/assets/trending/dwarkadhish.webp",
                slug: "dwarkadhish-temple",
                deity: "Lord Krishna",
                keywords: ["dwarka", "krishna", "gujarat", "char dham", "dwarkadhish", "mathura"]
            },
            {
                type: "temple",
                name: "Ramanathaswamy Temple",
                location: "Rameswaram, Tamil Nadu",
                route: "/ramanathaswamy-temple",
                image: "/assets/trending/rameshwaram.webp",
                slug: "ramanathaswamy-temple",
                deity: "Lord Shiva",
                keywords: ["rameswaram", "rameshwaram", "ramanathaswamy", "shiva", "tamil nadu", "char dham", "jyotirlinga"]
            },
            {
                type: "temple",
                name: "Amarnath Cave Temple",
                location: "Anantnag, Jammu & Kashmir",
                route: "/amarnath",
                image: "/assets/tample/amarnath-temple.svg",
                slug: "amarnath",
                deity: "Lord Shiva",
                keywords: ["amarnath", "baba barfani", "shiva", "kashmir", "cave", "himalayas", "yatra", "jammu & kashmir"]
            }
        ];

        const prioritySlugs = new Set(priorityTemples.map((t) => t.slug));

        // All remaining temples from templesData (temple listing dataset)
        const datasetTemples = templesData
            .filter((t) => !prioritySlugs.has(t.slug))
            .map((t) => {
                const loc = t.generalInfo?.location || "";
                const deity = t.generalInfo?.deity || "";
                const slugWords = (t.slug || "").split("-").filter(Boolean);
                const locWords = loc.toLowerCase().split(/[\s,()]+/).filter(Boolean);
                const deityWords = deity.toLowerCase().split(/[\s,()]+/).filter(Boolean);

                return {
                    type: "temple",
                    name: t.generalInfo?.templeName || "",
                    location: loc,
                    route: `/temple/${t.slug}`,
                    image: t.images?.thumbnailImage || t.images?.timingImage || "/assets/banner/detail-image.svg",
                    slug: t.slug,
                    deity: deity,
                    keywords: [
                        deity,
                        loc,
                        t.slug,
                        ...slugWords,
                        ...locWords,
                        ...deityWords
                    ].filter(Boolean)
                };
            });

        // All 36 States & Union Territories of India
        const statesList = allStatesData.map((s) => ({
            type: "state",
            name: s.name,
            id: s.id,
            location: s.location || "State • India",
            image: s.image,
            route: s.route,
            keywords: s.keywords || [s.name, "state", "india"]
        }));

        // 168+ Sacred Cities & Cultural Towns of India
        const citiesList = allCitiesData.map((c) => ({
            type: "city",
            name: c.name,
            state: c.state,
            query: c.query,
            location: `${c.state}, India`,
            image: c.image,
            route: `/listing?search=${encodeURIComponent(c.query || c.name)}`,
            keywords: [...(c.keywords || []), "city", "sacred", c.state]
        }));

        // Special category exploration links
        const categoryLinks = [
            {
                type: "temple",
                name: "12 Jyotirlingas Darshan",
                location: "Sacred Shrines Across India",
                route: "/jyotirlingas",
                image: "/assets/home/what-to-do/temple-1.webp",
                keywords: ["jyotirlinga", "12 jyotirlingas", "somnath", "mahakaleshwar", "omkareshwar", "trimbakeshwar", "shiva", "kedarnath", "kashi", "mallikarjuna", "baidyanath"]
            },
            {
                type: "temple",
                name: "51 Shaktipeeth Temples",
                location: "Divine Shrines Across India",
                route: "/devi-temple",
                image: "/assets/trending/bhadrakali-temple.webp",
                keywords: ["devi", "shaktipeeth", "51 shaktipeeth", "durga", "kali", "kamakhya", "bhadrakali", "shakti", "mansa devi", "chintpurni", "jwala ji"]
            },
            {
                type: "temple",
                name: "VR Temple Darshan",
                location: "360° Virtual Pilgrimage",
                route: "/vr-darshan",
                image: "/assets/banner/vr-darshan/temples/aarti.webp",
                keywords: ["vr", "darshan", "virtual reality", "360", "live aarti", "experience", "virtual darshan"]
            },
            {
                type: "temple",
                name: "India Pilgrimage Map",
                location: "Interactive Sacred Map of India",
                route: "/india-temples",
                image: "/assets/home/icons/service-icon-1.webp",
                keywords: ["map", "india", "pilgrimage", "route", "yatra", "temple guide", "sacred map"]
            }
        ];

        return [...priorityTemples, ...datasetTemples, ...statesList, ...citiesList, ...categoryLinks];
    }, []);

    const filteredTemples = useMemo(() => {
        const query = searchQuery.toLowerCase().trim();
        if (!query) {
            // Return ALL items so user can scroll through entire temple, state & city listing
            return searchableTemples;
        }

        const queryWords = query.split(/\s+/).filter(Boolean);

        return searchableTemples.filter((item) => {
            const name = (item.name || "").toLowerCase();
            const location = (item.location || "").toLowerCase();
            const deity = (item.deity || "").toLowerCase();
            const state = (item.state || "").toLowerCase();
            const keywords = (item.keywords || []).map((k) => (k || "").toLowerCase());

            // 1. Direct query match
            if (name.includes(query) || location.includes(query) || deity.includes(query) || state.includes(query)) {
                return true;
            }

            // 2. Direct keyword match
            if (keywords.some((k) => k.includes(query))) {
                return true;
            }

            // 3. Multi-word search (every token in queryWords matches somewhere in combined text)
            const combinedText = `${name} ${location} ${deity} ${state} ${keywords.join(" ")}`;
            return queryWords.every((word) => combinedText.includes(word));
        });
    }, [searchQuery, searchableTemples]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setShowSuggestions(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
        };
    }, []);

    const handleSearchSubmit = (e) => {
        if (e) e.preventDefault();
        const val = searchQuery.trim();
        if (!val) {
            navigate("/india-temples");
            setShowSuggestions(false);
            return;
        }
        if (filteredTemples.length > 0) {
            navigate(filteredTemples[0].route);
        } else {
            navigate("/coming-soon");
        }
        setShowSuggestions(false);
    };

    const handleSelectItem = (item) => {
        setSearchQuery(item.name);
        setShowSuggestions(false);
        navigate(item.route);
    };

    return (
        <>

            <style>{`
        .header {
          display: none;
        }

        .newsLetter {
          display: none;
        }

        .copyright {
          display: none;
        }

        .footer {
          display: none;
        }
      `}</style>
            <div className="homeHero">
                <div className="homeHeroOverlay" />

                {/* ================= HEADER ================= */}
             
                <HeaderNew />

                {/* ================= HERO ================= */}
                <div className="heroContainer">
                    <Container maxWidth="lg" >
                        <Grid container>
                            <Grid size={{ xs: 12, lg: 8 }}>
                                <div className="heroContent">
                                    <h1>
                                        Begin Your
                                        <br />
                                        Divine Journey
                                    </h1>

                                    <p>
                                        Discover sacred places, plan your trip,
                                        access trusted
                                        <br className="desktopBreak" />
                                        services &amp; experience the spiritual
                                        essence of India.
                                    </p>

                                    <div className="heroSearchWrapper" ref={searchRef}>
                                        <form
                                            className="heroSearch"
                                            onSubmit={handleSearchSubmit}
                                        >
                                            <div className="searchField">
                                                <input
                                                    type="text"
                                                    placeholder="Search a state, city or temple..."
                                                    title="Search a state, city or temple..."
                                                    aria-label="Search a state, city or temple..."
                                                    value={searchQuery}
                                                    onChange={(e) => {
                                                        setSearchQuery(e.target.value);
                                                        setShowSuggestions(true);
                                                    }}
                                                    onFocus={() => setShowSuggestions(true)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Escape") {
                                                            setShowSuggestions(false);
                                                        }
                                                    }}
                                                />
                                                {searchQuery && (
                                                    <button
                                                        type="button"
                                                        className="clearSearchBtn"
                                                        onClick={() => setSearchQuery("")}
                                                        aria-label="Clear search"
                                                    >
                                                        &times;
                                                    </button>
                                                )}
                                            </div>

                                            <button type="submit">
                                                EXPLORE
                                            </button>
                                        </form>

                                        {showSuggestions && (
                                            <div className="searchSuggestionsDropdown">
                                                <div className="suggestionsHeader">
                                                    {searchQuery.trim() === ""
                                                        ? `All Locations & Temples (${filteredTemples.length})`
                                                        : `${filteredTemples.length} ${filteredTemples.length === 1 ? "Result" : "Results"} Found`}
                                                </div>

                                                {filteredTemples.length > 0 ? (
                                                    <ul className="suggestionsList">
                                                        {filteredTemples.map((item, idx) => (
                                                            <li
                                                                key={`${item.type || "item"}-${item.name}-${idx}`}
                                                                className="suggestionItem"
                                                                onClick={() => handleSelectItem(item)}
                                                            >
                                                                <img
                                                                    src={item.image || "/assets/trending/kedarnath.webp"}
                                                                    alt={item.name}
                                                                    className="suggestionThumb"
                                                                    onError={(e) => {
                                                                        e.target.src = "/assets/trending/kedarnath.webp";
                                                                    }}
                                                                />
                                                                <div className="suggestionInfo">
                                                                    <div className="suggestionTitleRow">
                                                                        <span className="suggestionName">{item.name}</span>
                                                                        {item.type && (
                                                                            <span className={`typeBadge badge-${item.type}`}>
                                                                                {item.type === "temple" ? "Temple" : item.type === "state" ? "State" : "City"}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                    <span className="suggestionLocation">
                                                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="#00c2af">
                                                                            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                                                                        </svg>
                                                                        {item.location}
                                                                    </span>
                                                                </div>
                                                                <span className="suggestionArrow">
                                                                    <ArrowForward style={{ fontSize: "16px" }} />
                                                                </span>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                ) : (
                                                    <div className="noResultsFound">
                                                        <p>No results found matching "{searchQuery}"</p>
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                navigate("/india-temples");
                                                                setShowSuggestions(false);
                                                            }}
                                                        >
                                                            Browse India Temples
                                                        </button>
                                                    </div>
                                                )}

                                                <div className="suggestionsFooter">
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            navigate("/india-temples");
                                                            setShowSuggestions(false);
                                                        }}
                                                    >
                                                        Browse All in India Directory &rarr;
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Container>
                </div>

                {/* ================= SERVICES ================= */}
                {/* <div className="servicesSection">
                    <Container maxWidth="lg">
                        <div className="servicesSliderWrap">

                            <Swiper
                                modules={[Autoplay, Navigation]}
                                className="servicesSwiper"
                                spaceBetween={14}
                                slidesPerView={8}
                                loop={true}
                                navigation={{
                                    nextEl: ".servicesNext",
                                    prevEl: ".servicesPrev",
                                }}
                                breakpoints={{
                                    0: {
                                        slidesPerView: 2,
                                        spaceBetween: 10,
                                    },

                                    480: {
                                        slidesPerView: 2.5,
                                        spaceBetween: 10,
                                    },

                                    576: {
                                        slidesPerView: 3,
                                        spaceBetween: 12,
                                    },

                                    768: {
                                        slidesPerView: 4,
                                        spaceBetween: 14,
                                    },

                                    992: {
                                        slidesPerView: 6,
                                        spaceBetween: 14,
                                    },

                                    1200: {
                                        slidesPerView: 8,
                                        spaceBetween: 14,
                                    },

                                    1600: {
                                        slidesPerView: 8,
                                        spaceBetween: 18,
                                    },
                                }}
                            >
                                {services.map((service, index) => (
                                    <SwiperSlide key={index}>
                                        <a
                                            href={service.link}
                                            className="serviceCard"
                                        >
                                            <div className="serviceIcon">
                                                {service.icon && (
                                                    <img
                                                        src={service.icon}
                                                        alt={service.name || "Pilgrimage service"}
                                                    />
                                                )}
                                            </div>

                                            <div className="serviceTitle">
                                                {service.title}
                                            </div>
                                        </a>
                                    </SwiperSlide>
                                ))}

                                <button
                                    className="servicesPrev"
                                    aria-label="Previous"
                                >
                                    <span>‹</span>
                                </button>

                                <button
                                    className="servicesNext"
                                    aria-label="Next"
                                >
                                    <span>›</span>
                                </button>
                            </Swiper>

                        </div>
                    </Container>
                </div> */}
            </div>

            

            <section className="bodyBg whiteBg">
                <Container maxWidth="lg">
                    <Grid container spacing={4}>
                        <Grid
                            size={{
                                xl: 12,
                                lg: 12,
                                md: 12,
                                sm: 12,
                                xs: 12,
                            }}
                        >
                            <div className="whatToDoSection pb-0">
                                
                                {/* ================= FAMOUS TEMPLES SECTION ================= */}
                                <div className="famousTemplesBlock">
                                    <Container maxWidth="lg">
                                        <div className="commonSectionHeading headingWithBtn">
                                            <div className="headingText">
                                                <h2>Famous Temples in India</h2>
                                                <h3>Explore India’s iconic spiritual landmarks</h3>
                                            </div>
                                            <a href="/listing" className="viewAllBtn">
                                                View All
                                            </a>
                                        </div>

                                        {/* Desktop 5 Columns */}
                                        <Box sx={{ display: { xs: "none", md: "block" } }}>
                                            <div className="templeCardsGrid">
                                                {famousTemples.map((temple, index) => (
                                                    <a
                                                        key={index}
                                                        href={temple.link}
                                                        className="famousTempleCard"
                                                    >
                                                        <img
                                                            src={temple.image}
                                                            alt={temple.title}
                                                        />
                                                        <div className="templeCardOverlay" />
                                                        <span className="templeCardName">
                                                            {temple.title}
                                                        </span>
                                                    </a>
                                                ))}
                                            </div>
                                        </Box>

                                        {/* Mobile / Tablet Slider */}
                                        <Box sx={{ display: { xs: "block", md: "none" } }}>
                                            <Swiper
                                                modules={[Pagination, Autoplay]}
                                                className="famousTemplesSwiper"
                                                spaceBetween={12}
                                                slidesPerView={1.8}
                                                pagination={{
                                                    clickable: true,
                                                }}
                                                breakpoints={{
                                                    480: {
                                                        slidesPerView: 2.2,
                                                        spaceBetween: 12,
                                                    },
                                                    600: {
                                                        slidesPerView: 2.8,
                                                        spaceBetween: 14,
                                                    },
                                                    768: {
                                                        slidesPerView: 3.5,
                                                        spaceBetween: 15,
                                                    },
                                                }}
                                            >
                                                {famousTemples.map((temple, index) => (
                                                    <SwiperSlide key={index}>
                                                        <a
                                                            href={temple.link}
                                                            className="famousTempleCard"
                                                        >
                                                            <img
                                                                src={temple.image}
                                                                alt={temple.title}
                                                            />
                                                            <div className="templeCardOverlay" />
                                                            <span className="templeCardName">
                                                                {temple.title}
                                                            </span>
                                                        </a>
                                                    </SwiperSlide>
                                                ))}
                                            </Swiper>
                                        </Box>
                                    </Container>
                                </div>

                                {/* ================= WHAT WOULD YOU LIKE TO DO ================= */}
                                <Container maxWidth="lg">
                                    <div className="commonSectionHeading headingWithBtn">
                                        <div className="headingText">
                                            <h2>Crafted services, just for you</h2>
                                            <h3>Tailored solutions to meet your unique needs</h3>
                                        </div>
                                        <a href="#" className="viewAllBtn">
                                            View All
                                        </a>
                                    </div>

                                    {/* Desktop */}
                                    <Box sx={{ display: { xs: "none", md: "block" } }}>
                                        <Grid container spacing={3}>
                                            {actionCards.map((card, index) => (
                                                <Grid
                                                    key={index}
                                                    size={{
                                                        xl: 3,
                                                        lg: 3,
                                                        md: 6,
                                                    }}
                                                >
                                                    <a href={card.link} className="actionCard">
                                                        <img src={card.image} alt={card.title} />

                                                        <div className="actionOverlay"></div>

                                                        <div className="actionContent">
                                                            <h3>{card.title}</h3>
                                                            <p>{card.description}</p>
                                                        </div>

                                                        <span className="actionArrow">→</span>
                                                    </a>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </Box>

                                    {/* Mobile Slider */}
                                    <Box sx={{ display: { xs: "block", md: "none" } }}>
                                        <Swiper
                                            modules={[Pagination, Autoplay]}
                                            className="actionCardsSwiper"
                                            spaceBetween={15}
                                            slidesPerView={1.15}
                                            pagination={{
                                                clickable: true,
                                            }}
                                            // autoplay={{
                                            //     delay: 3000,
                                            //     disableOnInteraction: false,
                                            // }}
                                            loop={actionCards.length > 3}
                                            breakpoints={{
                                                768: {
                                                    slidesPerView: 2.5,
                                                    spaceBetween: 15,
                                                },
                                            }}
                                        >
                                            {actionCards.map((card, index) => (
                                                <SwiperSlide key={index}>
                                                    <a href={card.link} className="actionCard">
                                                        <img src={card.image} alt={card.title} />

                                                        <div className="actionOverlay"></div>

                                                        <div className="actionContent">
                                                            <h3>{card.title}</h3>
                                                            <p>{card.description}</p>
                                                        </div>

                                                        <span className="actionArrow">→</span>
                                                    </a>
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                    </Box>
                                </Container>

                                {/* ================= RENT A LOCKER BANNER ================= */}
                                <div className="rentLockerBanner">
                                    <Container maxWidth="lg">
                                        <Grid container className="rentLockerGrid">
                                            {/* LEFT CONTENT */}
                                            <Grid
                                                size={{
                                                    xl: 6,
                                                    lg: 6,
                                                    md: 7,
                                                    sm: 12,
                                                    xs: 12,
                                                }}
                                            >
                                                <div className="rentLockerContent">
                                                    <h2>
                                                        <span className="tealHeading">Rent a Locker,</span>
                                                        <br />
                                                        <span className="darkHeading">Stress-Free Darshan</span>
                                                    </h2>
                                                    <div className="rentLockerAccentBar" />
                                                    <p>
                                                        A secure and convenient way to store your belongings while you focus on what truly matters.
                                                    </p>
                                                    <a href="locker" className="rentLockerBtn">
                                                        Book Your Locker Now
                                                    </a>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Container>
                                </div>

                                {/* ================= APP BANNER ================= */}
                                <div className="appBanner">
                                    <Container maxWidth="lg">
                                        <Grid container className="appBannerGrid">
                                            {/* LEFT CONTENT */}
                                            <Grid
                                                size={{
                                                    xl: 5,
                                                    lg: 5,
                                                    md: 5,
                                                    sm: 12,
                                                    xs: 12,
                                                }}
                                            >
                                                <div className="appBannerContent">
                                                    <h2>
                                                        Experience the Divine with
                                                        <br />
                                                        MandirWiki App
                                                    </h2>

                                                    <p>
                                                        Unlock exclusive features like VR Darshan, AR Navigation, Audio
                                                        Guide and more only on the app.
                                                    </p>

                                                    <span className="downloadText">Download the App</span>

                                                    <div className="appStoreButtons">
                                                        <a
                                                            href="https://play.google.com/store/apps/details?id=com.mandir.wiki&pcampaignid=web_share"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="storeButton"
                                                            aria-label="Get it on Google Play"
                                                        >
                                                            <img
                                                                src="/assets/home/icons/google-play.png"
                                                                alt="Get it on Google Play"
                                                                className="img-fluid"
                                                            />
                                                        </a>

                                                        <a
                                                            href="/coming-soon"
                                                            className="storeButton"
                                                            aria-label="Download on the App Store"
                                                        >
                                                            <img
                                                                src="/assets/home/icons/app-store.png"
                                                                alt="Download on the App Store"
                                                                className="img-fluid"
                                                            />
                                                        </a>
                                                    </div>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Container>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Container>

                {/* devotees section start */}

                <section className="px-0 pb-0">
                    <Container maxWidth="lg">
                        <div className="statsSection">
                            <Grid container className="statsGrid">
                                {/* 7 Lakh+ */}
                                <Grid size={{ xl: 2.4, lg: 2.4, md: 4, sm: 6, xs: 6 }}>
                                    <div className="statsCard">
                                        <img src="/assets/home/icons/devotees-icon.png" alt="7 Lakh+ Devotees Served" />
                                        <div>
                                            <h3>1M +</h3>
                                            <p>Devotees Served</p>
                                        </div>
                                    </div>
                                </Grid>

                                <Grid size={{ xl: 3, lg: 3, md: 4, sm: 6, xs: 6 }}>
                                    <div className="statsCard">
                                        <img src="/assets/home/icons/onsite-booking-icon.png" alt="App, Web, WhatsApp & Onsite Booking" />
                                        <div>
                                            <h3>App, Web, WhatsApp</h3>
                                            <p>& Onsite Booking</p>
                                        </div>
                                    </div>
                                </Grid>

                                <Grid size={{ xl: 1.8, lg: 1.8, md: 4, sm: 6, xs: 6 }}>
                                    <div className="statsCard">
                                        <img src="/assets/home/icons/destination-icon.png" alt="100+ Planned Destinations" />
                                        <div>
                                            <h3>100+ Planned</h3>
                                            <p>Destinations</p>
                                        </div>
                                    </div>
                                </Grid>

                                <Grid size={{ xl: 2.4, lg: 2.4, md: 4, sm: 6, xs: 6 }}>
                                    <div className="statsCard">
                                        <img src="/assets/home/icons/smart-watch-icon.png" alt="Smart Services at Major Pilgrimage Sites" />
                                        <div>
                                            <h3>Smart Services at</h3>
                                            <p>Major Pilgrimage Sites</p>
                                        </div>
                                    </div>
                                </Grid>

                                <Grid size={{ xl: 2.4, lg: 2.4, md: 4, sm: 6, xs: 6 }}>
                                    <div className="statsCard">
                                        <img src="/assets/home/icons/startup-icon.png" alt="Startup India Recognised" />
                                        <div>
                                            <h3>Startup India</h3>
                                            <p>Recognised</p>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </Container>
                </section>

                {/* devotees section end */}

                {/* seamless travel solutions section start */}
                <section className="seamlessTravelSection">
                    <Container maxWidth="lg">
                        <div className="commonSectionHeading">
                            <h2>Seamless Travel Solutions</h2>
                            <h3>Travel smooth. Travel smart.</h3>
                        </div>

                        <div className="travelGridContainer">
                            {/* Hotel Card */}
                            <div className="travelCard travelHotelCard">
                                <a href="hotel">
                                    <img src="/assets/home/travel-hotel.png" alt="Pilgrimage Hotel Booking" />
                                    <div className="travelCardOverlay"></div>
                                    <h3 className="travelCardTitle">Hotel</h3>
                                </a>
                            </div>

                            {/* Right Column: Bus on top, Flight + Cabs on bottom */}
                            <div className="travelRightCol">
                                <div className="travelCard travelBusCard">
                                    <a href="coming-soon">
                                        <img src="/assets/home/travel-bus.webp" alt="Pilgrimage Bus Booking" />
                                        <div className="travelCardOverlay"></div>
                                        <h3 className="travelCardTitle">Bus</h3>
                                    </a>
                                </div>

                                <div className="travelBottomRow">
                                    <div className="travelCard travelFlightCard">
                                        <a href="coming-soon">
                                            <img src="/assets/home/travel-flight.webp" alt="Pilgrimage Flight Booking" />
                                            <div className="travelCardOverlay"></div>
                                            <h3 className="travelCardTitle">Flight</h3>
                                        </a>
                                    </div>
                                    <div className="travelCard travelCabsCard">
                                        <a href="coming-soon">
                                            <img src="/assets/home/travel-cabs.webp" alt="Pilgrimage Cab and Taxi Services" />
                                            <div className="travelCardOverlay"></div>
                                            <h3 className="travelCardTitle">Cabs</h3>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Container>
                </section>
                {/* seamless travel solutions section end */}

               <section className="latestBlogs bg-white pb-0">
    <Container maxWidth="lg">
        <div className="commonSectionHeading">
            <h2>Explore Latest Blogs</h2>
        </div>

        <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            className="latestBlogsSwiper"
            spaceBetween={30}
            slidesPerView={4}
            loop={true}
            navigation
            pagination={{
                clickable: true,
            }}
            autoplay={{
                delay: 3000,
                disableOnInteraction: false,
            }}
            breakpoints={{
                0: {
                    slidesPerView: 1,
                    spaceBetween: 15,
                },
                576: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
            }}
        >
            {blogs.map((blog, index) => (
                <SwiperSlide key={index}>
                    <article className="blogCard">
                        <div className="blogImage">
                            <img
                                src={blog.image}
                                alt={blog.title}
                            />
                        </div>

                        <div className="blogContent">
                            <h3>{blog.title}</h3>

                            <p>{blog.description}</p>

                            <div className="blogFooter">
                                <a
                                    href={blog.link}
                                    className="readMoreBtn"
                                >
                                    Read Full Article
                                </a>
                            </div>
                        </div>
                    </article>
                </SwiperSlide>
            ))}
        </Swiper>
    </Container>
</section>

            </section>

            <section className="mysteriesSection">
                <Container maxWidth="lg">
                    <div className="commonSectionHeading">
                        <h2>Mysteries and Marvels of Temples</h2>
                    </div>

                    <Swiper
                        modules={[Autoplay]}
                        className="mysteriesSwiper"
                        spaceBetween={20}
                        slidesPerView={1}
                        speed={1000}
                        loop={true}
                        grabCursor={true}
                        autoplay={{
                            delay: 5000,
                            disableOnInteraction: false,
                        }}
                        onSwiper={(swiper) => {
                            setMysterySwiper(swiper);
                            swiper.autoplay?.stop?.();
                        }}
                        onSlideChange={(swiper) => setMysteryIndex(swiper.realIndex)}
                    >
                        {templeMysteries.map((slide, index) => (
                            <SwiperSlide key={index}>
                                <div className="mysteryCard">
                                    {slide.banner ? (
                                        <>
                                            <div className="mysteryBannerDesktop">
                                                <img src={slide.banner} alt={slide.title} className="mysteryBannerImg" />
                                                <div className="mysteryBannerContent">
                                                    <div className="mysteryTrishulBadge">
                                                        <span className="trishulLine"></span>
                                                        <span className="trishulIcon">🔱</span>
                                                        <span className="trishulLine"></span>
                                                    </div>
                                                    <h3 className="mysterySerifTitle">{slide.subtitle}</h3>
                                                    <div className="mysteryYellowBadge">{slide.tag}</div>
                                                    {slide.paragraphs.map((p, pIdx) => (
                                                        <p key={pIdx}>{p}</p>
                                                    ))}
                                                </div>
                                            </div>
                                            <div className="mysteryCardMobile">
                                                <div className="mysteryCardImgWrap">
                                                    <img src={slide.image || slide.banner} alt={slide.title} />
                                                </div>
                                                <div className="mysteryCardContent">
                                                    <div className="mysteryTrishulBadge">
                                                        <span className="trishulLine"></span>
                                                        <span className="trishulIcon">🔱</span>
                                                        <span className="trishulLine"></span>
                                                    </div>
                                                    <h3 className="mysterySerifTitle">{slide.subtitle}</h3>
                                                    <div className="mysteryYellowBadge">{slide.tag}</div>
                                                    {slide.paragraphs.map((p, pIdx) => (
                                                        <p key={pIdx}>{p}</p>
                                                    ))}
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="mysteryCardLayout">
                                            <div className="mysteryCardImgWrap">
                                                <img src={slide.image} alt={slide.title} />
                                            </div>
                                            <div className="mysteryCardContent">
                                                <div className="mysteryTrishulBadge">
                                                    <span className="trishulLine"></span>
                                                    <span className="trishulIcon">🔱</span>
                                                    <span className="trishulLine"></span>
                                                </div>
                                                <h3 className="mysterySerifTitle">{slide.subtitle}</h3>
                                                <div className="mysteryYellowBadge">{slide.tag}</div>
                                                {slide.paragraphs.map((p, pIdx) => (
                                                    <p key={pIdx}>{p}</p>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>

                    {/* Bottom Controls */}
                    <div className="mysteryControls">
                        <button
                            type="button"
                            className="mysteryArrowBtn"
                            onClick={handleMysteryPrev}
                            aria-label="Previous Slide"
                        >
                            <ArrowBack />
                        </button>

                        <div className="mysteryCenterControls">
                            <div className="mysteryProgressTrack">
                                <div
                                    className="mysteryProgressIndicator"
                                    style={{
                                        width: `${(1 / templeMysteries.length) * 100}%`,
                                        transform: `translateX(${mysteryIndex * 100}%)`,
                                    }}
                                />
                            </div>

                            <button
                                type="button"
                                className="mysteryPlayPauseBtn"
                                onClick={toggleMysteryPlay}
                                aria-label={mysteryPlaying ? "Pause Slider" : "Play Slider"}
                            >
                                {mysteryPlaying ? <Pause /> : <PlayArrow />}
                            </button>
                        </div>

                        <button
                            type="button"
                            className="mysteryArrowBtn"
                            onClick={handleMysteryNext}
                            aria-label="Next Slide"
                        >
                            <ArrowForward />
                        </button>
                    </div>
                </Container>
            </section>

            
        </>
    );
}

export default HomePageWhite;
